/**
 * DOM and formatting utilities.
 *
 * Unit conversion is inline (rather than pulling a 204 KB value-unit
 * dependency for 13 lines of code). `getRootEm()` covers the only
 * units this codebase ever resolves.
 */

/** Read the document root's computed font-size in pixels. */
function getRootEm(): number {
    return parseFloat(getComputedStyle(document.documentElement).fontSize);
}

/** Strip trailing zeros from a numeric string: "22.0" → "22", "5.50" → "5.5" */
export function stripTrailingZeros(s: string): string {
    if (!s.includes(".")) return s;
    return s.replace(/\.?0+$/, "");
}

/** Convert a CSS length string (e.g. "1.5em", "16px") to pixels. */
export function emToPixels(value: string): number {
    value = value.toLowerCase().trim();
    const num = parseFloat(value);
    if (isNaN(num)) return 0;

    if (value.endsWith("px")) return num;
    // `em` and `rem` both resolve against the document root here — the
    // historical `convertToPixels(num, "em")` call did the same when no
    // element was supplied (it defaulted to documentElement).
    if (value.endsWith("em") || value.endsWith("rem")) return num * getRootEm();

    // Bare number — assume em.
    return num * getRootEm();
}

/** Get the computed value of a CSS custom property. */
export function getComputedVariable(v: string, el = document.documentElement): string {
    return window.getComputedStyle(el).getPropertyValue(v);
}
